export default {
  appName: "GISagro 4.0",
  appTitle: "โปรแกรมวาดแปลง",
  appSubTitle: "บริการภูมิสารสนเทศเพื่อการเกษตร",

  th: "ไทย",
  a: "",
  an: "",

  about: 'เกี่ยวกับ',
  aboutUs: "เกี่ยวกับเรา",
  above: "",
  accept: "รับงาน",
  account: "แอคเคาท์",
  accountId: "รหัสแอคเคาท์",
  address: "ที่อยู่",
  addressNo: "เลขที่",
  addressMoo: "หมู่ที่",
  addressVill: "ชื่อหมู่บ้าน",
  addressFloor: "ชั้นที่",
  addressBuilding: "ชื่ออาคาร",
  alreadyRegistered: "ได้ลงทะเบียนไปแล้ว",
  atLeast4Letters: "4-12 ตัวอักษรหรือตัวเลข",
  atLeast6Letters: "6 ตัวอักษรหรือตัวเลขขึ้นไป",

  systemAdmin: "การดูแลระบบ",
  admin: "แอดมิน",
  administrator: "ผู้ดูแลระบบ",
  adminOfficialAccount: "กลุ่มแชทสาธารณะ",
  adminServiceCatalog: "ประเภทคำร้องขอ",
  adminTeam: "การดูแลข้อมูลทีมงาน",
  adminUser: "การดูแลข้อมูลผู้ใช้",
  adminOrganization: "การดูแลข้อมูลหน่วยงาน",
  adminUserLog: "ประวัติการใช้งาน",
  adminNews: "ข่าวประชาสัมพันธ์",

  add: "สร้าง",
  addTo: "เพิ่ม",
  addToGISagro: "เพิ่มลงในชั้นข้อมูลแปลง",
  again: "อีกครัง",
  againZH: "",
  ago: "ที่แล้ว",
  agree: "ยอมรับ",
  agreeWith: "ยอมรับ",
  album: "อัลบั้ม",
  all: "ทั้งหมด",
  alley: "ซอย",
  allSelected: "ได้เลือกทั้งหมด",
  and: "และ",
  andOr: "และ/หรือ",
  aor: "พื้นที่รับผิดชอบ",
  area: "พื้นที่",
  area2: "เนื้อที่",
  askFor: "ขอ",
  assignee: "ผู้ปฏิบัติงาน",
  assignment: "มอบหมายงาน",
  asWellAs: "และ",
  attention: "โปรดทราบ",
  atTime: "เวลา",
  avatar: "รูปถ่ายส่วนตัว",
  back: "กลับ",
  background: "ภาพพื้นหลัง",
  baseLayers: "ข้อมูลภูมิสารสนเทศพื้นฐาน",
  birthday: "วันเกิด",
  block: "ปิดกั้น",
  blockedList: "บล็อคลิสต์",
  bounded: "ผูกติดกัน",
  brand: "ยี่ห้อ",
  browse: "อ่านดู",
  calculateData: "คำนวณข้อมูล",
  camera: "กล้อง",
  cancel: "ยกเลิก",
  captcha: "CAPTCHA",
  catchword: "คำขวัญ",
  category: "ประเภทเรื่อง",
  category2: "ประเภท",
  change: "เปลี่ยน",

  channelTypeDirect: "ส่วนตัว",
  channelTypePrivate: "เฉพาะกลุ่ม",
  channelTypePublic: "สาธารณะ",

  chat: "แชท",
  chats: "แชท",
  chatUs: "แชทกับเรา",
  chinese: "จีน",
  click: "คลิก",
  clickAt: "คลิกที่",
  clickToReadDetails: "คลิกเพื่ออ่านรายละเอียด",
  clickToSelectPhoto: "คลิกที่รูปเพื่อเลื่อก เลื่อกอย่างน้อน 1 รูป",
  close: " ปิด ",
  closeJob: "ปิดงาน",
  code: "รหัส",
  comma: " ",
  comment: "ความคิดเห็น",
  conclusion: "สรุปผล",
  conditions: "",
  confirm: "ยืนยัน",
  confirmationCode: "รหัสยืนยัน",
  contacts: "ผู้ติดต่อ",
  contactUs: "ติดต่อเรา",
  contactTypeBlocked: "ปิดกั้น",
  contactTypeGroup: "กลุ่มเพื่อน",
  contactTypeIndividual: "เพื่อน",
  contactTypeInvited: "เพื่อนใหม่",
  contactTypeOfficial: "บริการสาธารณะ",
  coordinate: "พิกัด",
  correction: "แก้ไข",
  copyrightHallo: "2560",
  country: "ประเทศ",
  county: "อำเภอ",
  countyName: "ชื่ออำเภอ",
  cubicMeterPerRai: "ลบ.ม./ไร่",
  create: "สร้าง",
  
  crop: "พืช",
  cropRice: "ข้าว",
  cropMaize: "ข้าวโพด",
  cropSugarcane: "อ้อย",
  cropCassava: "มันสําปะหลัง",

  cassava: "มันสําปะหลัง",
  coconut: "มะพร้าว",
  coffee: "กาแฟ",
  durian: "ทุเรียน",
  garden: "สวนผสม",
  longan: "ลำไย",
  maize: "ข้าวโพด",
  mangosteen: "มังคุด",
  palm: "ปาล์มน้ำมัน",
  pineapple: "สับปะรด",
  rambuton: "เงาะ",
  rice: "ข้าว",
  rubber: "ยางพารา",
  sugarcane: "อ้อย",

  daily: "ทุกวัน",
  dashboard: "แดชบอร์ด",
  data: "ข้อมูล",
  dateRange: "ช่วงเวลา",
  dateTime: "วันเวลา",
  dates: "ช่วงเวลา",
  day: "วัน",
  days: "วัน",
  description: "คำอธิบาย",
  details: "รายละเอียด",
  delete: "ลบ",
  diseaseAndPest: "โรคพืช",
  diseasesAndPests: "สถานการณ์โรค%s",
  displayName: "ชื่อ-นามสกุล / ชื่อเล่น",
  distance: "ระยะทาง",
  done: "เรียบร้อย",
  dol: "กรมที่ดิน",
  doubleQuote: "\"",
  download: "ดาวน์โหลด",
  downloadAsShapeFile: "ไฟล์ *.shp",
  downloadAsExcelFile: "ไฟล์ *.xlsx",
  downloadPlantData: "ข้อมูล%s",
  downloadShapeFile: "Shape ไฟล์ (*.zip)",
  downloadMapFile: "แผนที่รายจังหวัด (.pdf)",
  downloadReportFile: "รายงานรายจังหวัด (*.xlsx)",
  downloadRIDFile: "รายงานพื้นที่ชลประทาน (*.xlsx)",
  downloadPlantDisaster: "ภัยพิบัติรายสัปดาห์ (*.zip)",
  dragAndDropFileHere: "ลากไฟล์ (%s) มาวางลงที่นี่",
  dropFileHere: "วางไฟล์ลงที่นี้",
  edit: "ปรับปรุง",
  email: "อีเมล์",
  emailAddress: "ที่อยู่อีเมล์",
  endDate: "วันที่สิ้นสุด",
  english: "อังกฤษ",
  enlarge: "ขยาย",
  enter: "กรอก",
  error: "ผิดพลาด",
  extraInfo: "ข้อมูลเพิ่มเติม",
  failed: "ล้มเหลว",
  farmland: "แปลงปลูก",
  farmlandShape: "แผนที่แปลงปลูก (*.shp)",
  featureInfo: "รายละเอียดข้อมูล",
  feedback: "ข้อเสนอแนะ",
  female: "หญิง",
  file: "ไฟล์",
  files: "ไฟล์",
  fileHasNoData: "ไม่มีข้อมูลในไฟล์",
  fileSize: "ขนาดไฟล์",
  filterData: "กล่องข้อมูล",
  filterMap: "กล่องข้อมูลแผนที่",
  followingSettings: "ค่าส่วนนี้",
  formula: "สูตร",
  from: "จาก",
  fromZH: "",
  fullName: "ชื่อ-นามสกุล",
  faq: "คำถามที่พบบ่อย",
  forgot: "ลืม",
  friend: "เพื่อน",

  gap: "GAP",
  organicFood: "เกษตรอินทรีย์",
  rspo: "RSPO",
  
  gender: "เพศ",
  general: "ทั่วไป",
  givenName: "ชื่อจริง",
  giveYourComment: "เสนอความคิดเห็น",
  grant: "ให้สิทธิ์",
  group: "กลุ่ม",
  growingAreaEvery2Weeks: "พื้นที่ปลูก%sจากดาวเทียม",
  growingAreaIn: "ข้อมูลพื้นที่ปลูก%s",

  administrators: "ผู้ดูแลหลัก",
  applicationSupports: "ผู้ดูแล",
  executives: "ผู้บริหารระดับสูง",
  governors: "ผู้ว่าการ",
  managers: "ผู้จัดการ",
  directors: "ผู้อำนวยการ",
  divisionManagers: "ผอ.ฝ่าย",
  sectionChiefs: "หัวหน้าแผนก",
  teamLeads: "หัวหน้าทีม",
  teamMembers: "ลูกทีม",
  operators: "เจ้าหน้าที่เกษตร",
  operatorsOthers: "เจ้าหน้าที่หน่วยงาน",
  citizens: "เกษตรกร",
  businessMen: "นักธุรกิจ",
  Specialists: "นักวิชาการ",

  halfYear: "ครึ่งปี",
  hallo: "ฮัลโหล",
  halloId: "ฮัลโหลไอดี",
  halloUser: "ผู้ใช้ฮัลโหล",
  has: "มี",
  have: "มี",
  haveNo: "ไม่มี",
  height: "ความสูง",
  help: "ช่วยเหลือ",
  helpManual: "คู่มือการใช้งาน",
  hiUser: "สวัสดี! คุณ%s",
  home: "หน้าแรก",
  hour: "ชม.",
  hourly: "ทุกชั่วโมง",
  i: "ข้าพเจ้า",
  iAm: "ข้าพเจ้า",
  id: "รหัส",
  idCode: "รหัส",
  if: "ถ้า",
  iKnow: "ทราบแล้ว",
  image: "รูปภาพ",
  numberOfImages: "%s รูป",
  imageArchive: "คลังข้อมูลภาพ",
  imageCategory: "ประเภทรูปภาพ",
  imagingDate: "วันที่ถ่ายรูป",
  implementedDuring: "ดำเนินการระหว่างวันที่",
  implementedBy: "โดย",
  initials: "ชื่อย่อ",
  inRegardTo: "เกี่ยวกับเรื่อง",
  insert: "เพิ่ม",
  inService: "ให้บริการ",
  inTo: "เข้าไป",
  invalid: "ไม่ถูกต้อง",
  invalidEmail: "อีเมล์ไม่ถูกต้อง",
  invalidMobileNo: "หมายเลขมือถือต้องเป็นเลข 10 หลักเริ่มต้นด้วย 0",
  invalidSSN: "เลขประจำตัวฯ ไม่ถูกต้อง",
  invalidUsername: "ชื่อผู้ใช้ต้องเป็น 4-12 ตัวอักษร และ/หรือ ตัวเลข",
  invalidPassword: "รหัสผ่านต้องไม่น้อยกว่า 6 ตัวอักษร และ/หรือ ตัวเลข",
  passwordNotTheSame: "รหัสผ่านไม่ตรงกัน",
  irrigationArea: "พื้นที่ชลประทาน",
  is: "คือ",
  isNot: "ไม่ใช่",
  jobConclusion: "ผลการดำเนินงาน",
  jobCompletedOn: "วันที่และเวลาดำเนินการแล้วเสร็จ",
  jobName: "ชื่องาน",
  openJobPosition: "(ว่าง)",
  khun: 'คุณ',
  ka: "คะ",
  krub: "ครับ",
  kilometer: "กม.",
  landData: "ข้อมูลแปลง",
  landUploader1: "สนับสนุนไฟล์ในรูปแบบ *.gpx และ Shape",
  landUploader2: "ไฟล์ Shape ประกอบด้วยไฟล์ *.shp, *.dbf, *.prj และ *.cpg ซึ่งต้องเก็บไว้ในรูปแบบ *.zip ให้เป็นไฟล์เดี่ยว",
  landUploader3: "ระบบพิกัดเป็น WGS84 หรือตามที่กำหนดในไฟล์ *.prj",
  landUploader4: "รหัสภาษาเป็น UTF-8 หรือตามที่กำหนดในไฟล์ *.cpg",
  landUploader5: "ไม่สนับสนุนข้อมูลชนิด Complex และ Multi* Geometry",
  landUploader6: "ต้องมี Attributes ตามที่กำหนด คลิกที่นี่เพื่อ",
  landUploader7: "ดาวน์โหลด Template",
  landUploaderSupportedFiles: "สนับสนุนไฟล์ในรูปแบบ *.gpx และ Shape. ไฟล์ Shape ประกอบด้วยไฟล์ *.shp, *.dbf, *.prj และ *.cpg ซึ่งต้องเก็บไว้ในรูปแบบ *.zip ให้เป็นไฟล์เดี่ยว",
  language: "ภาษา",
  lastNDays: "%s วันที่ผ่านมา",
  lastOneMonth: "1 เดือนที่ผ่านมา",
  lastNMonths: "%s เดือนที่ผ่านมา",
  lastOneYear: "1 ปีที่ผ่านมา",
  lastNYears: "%s ปีที่ผ่านมา",
  latestUpdate: "อัพเดท ณ %s",
  latitude: "ละติจูด",
  latNorth: "N",//"เหนือ",
  latSourth: "S",//"ใต้",
  layer: "ชั้นข้อมูล",
  layers: "ชั้นข้อมูลแผนที่",
  legend: "สัญลักษณ์",
  lte: "ไม่เกิน",
  gte: "มากกว่า",
  between: "ระหว่าง",
  livingCountry: "ประเทศที่อาศัย",
  locatedIn: "อยู่ใน",
  locatePin: "กำหนดตำแหน่ง",
  location: "ตำแหน่ง",
  logAction: "การกระทำ",
  login: "ล็อกอิน",
  logining: "เ ข้ า สู่ ร ะ บ บ",
  loginWasNotSuccessful: "เข้าสู่ระบบไม่สำเร็จ",
  logout: "ล็อกเอาท์",
  lonEast: "E",//"ตะวันออก",
  longitude: "ลองจิจูด",
  lonWest: "W",//"ตะวันตก",
  male: "ชาย",
  manage: "จัดการ",
  me: "ฉัน",
  measure: "วัด",

  messageTypeFile: "ไฟล์",
  messageTypeHtml: "ลิงค์",
  messageTypeImage: "รูปภาพ",
  messageTypeLocation: "ตำแหน่ง",
  messageTypeSticker: "สติ๊กเกอร์",
  messageTypeVideo: "วิดีโอ",

  menuFile: "ไฟล์",
  menuFileNew: "สร้างไฟล์ใหม่",
  menuFileLocal: "เปิดไฟล์จากคอมฯ",
  menuFileServer: "เปิดไฟล์จากเซิร์ฟเวอร์",
  menuFileSave: "เก็บไฟล์ลงในคอมฯ",
  menuFileUpload: "อัพโหลดไฟล์",
  menuFileShare: "แชร์ไฟล์",
  menuFileDeleteFromServer: "ลบไฟล์จากเซิร์ฟเวอร์",
  menuFileProperties: "คุณสมบัติของไฟล์",
  menuFilePrint: "พิมพ์ไฟล์ ...",
  menuFileSaveAsFile: "บันทึกไฟล์",
  menuFileSaveAsPdf: "บันทึกเป็น PDF",
  menuFileSaveAsPng: "บันทึกเป็น PNG",
  
  menuData: "ข้อมูล",
  menuDataLocal: "เพิ่มข้อมูลจากคอมฯ",
  menuDataServer: "เพิ่มข้อมูลจากเซิร์ฟเวอร์",
  menuDataManage: "คำนวณข้อมูล",
  menuDataExport: "ส่งออกข้อมูล",
  menuDataExportZip: "ส่งออกเป็น Zip",
  menuDataExportExcel: "ส่งออกเป็น Excel",
  menuDataFilter: "กล่องข้อมูล",

  menuChart: "แผนภูมิ",
  menuChartTable: "ตาราง",
  menuChartPivot: "ตาราง Pivot",
  menuChartTableSum: "ตารางรวมยอด",
  menuChartBars: "กราฟแท่ง",
  menuChartLines: "กราฟเส้น",
  menuChartAreas: "กราฟพื้นที่",
  menuChartPie: "กราฟวงกลม",
  menuChartDonut: "กราฟโดนัท",
  menuChartGauge: "มิเตอร์วัดเกจ",
  menuChartComposite: "กราฟแบบผสม",
  menuChartScatter: "กราฟการกระจาย",
  menuChartBoxPlot: "กราฟลูกกล่อง",
  menuChartPallel: "กราฟแบบเส้นขนาน",
  menuChartTreemap: "แผนภูมิทรีแมป",
  menuChartMap: "แผนที่",

  meter: "ม.",
  member: "สมาชิก",
  mine: "ข้องฉัน",
  minute: "นาที",
  miss: "น.ส.",
  mr: "นาย",
  mrs: "นาง",
  mobile: "มือถือ",
  mobileNo: "เบอร์มือถือ",
  month: "เดือน",
  months: "เดือน",
  monthsText: ["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],
  more: "เพิ่มเติม...",
  moreThan: "มากกว่า",
  multipleSelected: "ได้เลือกมากกว่าหนึ่งตัว",
  music: "ดนตรี",
  my: "", //intentionally blank
  nDaysAgo: "%s วันที่แล้ว",
  nMonthsAgo: "%s เดือนที่แล้ว",
  nYearsAgo: "%s ปีที่แล้ว",
  oneDayAgo: "1 วันที่แล้ว",
  oneMonthAgo: "1 เดือนที่แล้ว",
  oneYearAgo: "1 ปีที่แล้ว",
  name: "ชื่อ",
  namePrefix: "คํานําหน้าชื่อ",
  nationalId: "เลขประจำตัวประชาชน",
  nationality: "สัญชาติ",
  nearTo: "บริเวณ",
  new: "",
  news: "ข่าวสาร",
  newUser: "ผู้ใช้ใหม่",
  newJobPosition: "ตำแหน่งใหม่",
  newRequest: "ยื่นคำขอ",
  next: "ถัดไป",
  nickname: "ชื่อเล่น",
  night: "กลางคืน",
  no: "ไม่",
  noData: "ไม่มีข้อมูล",
  noImage: "ไม่มีรูปภาพ",
  noEmailBounded: "ไม่ได้ผูกติดกับอีเมล์",
  noMobileBounded: "ไม่ได้ผูกติดกับมือถือ",
  noneSelected: "ไม่ได้เลือก",
  not: "ไม่ใช่",
  notRegistered: "ไม่พบข้อมูลลงทะเบียน",
  notSpecify: "ไม่กำหนด",
  notYet: "ยังไม่",
  notification: "แจ้งเตือน",
  notSet: "ยังไม่ตั้ง",
  notSupportedFile: "ไม่สนับสนุนไฟล์ประเภทต่างๆ ดังต่อไปนี้: ",
  number: "ตัวเลข",
  of: "ของ",
  ofAbove: "ข้างบน",
  ofBounded: "ที่ผูกติดกัน",
  officialAccount: "กลุ่มแชทสาธารณะ",
  ofPresent: "ปัจจุบัน",
  ofMine: "ของฉัน",
  ofNew: "ใหม่", 
  ofWithin: "",
  ofYours: "ของคุณ",
  ok: "ตกลง",
  onlineUsers: "ผู้ใช้งานปัจจุบัน",
  oneMonth: "1 เดือน",
  open: "เปิด",
  or: "หรือ",
  organization: "หน่วนงาน",
  organizationName: "ชื่อหน่วยงาน",
  organizationNameIsRequired: "กรอกชื่อหน่วยงานเป็นอย่างน้อย และกรณีระบุที่อยู่แล้วต้องเลือกจังหวัด อำเภอ ตำบล",
  otpCode: "รหัสยืนยัน",
  onMatterOf: "",
  others: "อื่นๆ",
  outFrom: "ออกจาก",
  ownerName: "เทศบาลนครปากเกร็ด",
  ownerName0: "สำนักช่าง",
  ownerName1: "จังหวัดนนทบุรี",
  ownerAddress: "เลขที่ 1 หมู่ 5 ถนนแจ้งวัฒนะ ต.ปากเกร็ด อ.ปากเกร็ด จ.นนทบุรี 11120 โทรศัพท์ (+66) 0-2960-9704~14",

  passportNo: "หมายเลขพาสปอร์ต",
  password: "รหัสผ่าน",
  permission: "สิทธิ",
  personality: "สไตล์",
  personInCharge: "ผู้รับผิดชอบ",
  phoneCall: "โทร.",
  photo: "ภาพถ่าย",
  place: "สถานที่",
  please: "โปรด",
  preferTo: "ดีฉันอยากใช้",
  preferTH: "มากกว่า",
  present: "",
  privacy: "ความเป็นส่วนตัว",
  privacyPolicy: "นโยบายความเป็นส่วนตัว",
  private: "ไม่เปิดเผย",
  privilege: "สิทธิการใช้งาน",
  policy: "นโยบาย",
  profile: "ข้อมูลส่วนตัว",
  province: "จังหวัด",
  provinceName: "ชื่อจังหวัด",
  public: "เปิดเผย",
  publish: "ส่งข่าว",
  QRCode: "คิวอาร์โค้ด",
  query: "สอบถาม",
  read: "อ่านแล้ว",
  remove: "ลบ",
  quickGuide: "วิธีการใช้งาน",
  reason: "เหตุผล",
  refuse: "ไม่รับ",
  refuseReason: "สาเหตุที่ไม่รับงานนี้",
  refuseNotInArea: "ไม่อยู่ในพื้นที่ของเทศบาล",
  refuseNotPublicProperty: "ไม่ใช่ทรัพย์สินของเทศบาล",
  refuseNotAbleToContactRequester: "ไม่สามารถติต่อผู้ร้องขอ",
  region: "ภูมิภาค",
  register: "ลงทะเบียน",
  registerOrganizations: "ลงทะเบียนหน่วยงาน",
  registerUsers: "ลงทะเบียนผู้ใช้",
  registerAnotherUser: "ลงทะเบียนผู้ใช้คนต่อไป?",
  registration: "ลงทะเบียน",
  reloadMap: "โหลดแผนที่ใหม่",
  request: "ร้องขอ",
  requests: "คำขอ",
  requester: "ผู้ขอ",
  requesterInfo: "ข้อมูลผู้ขอ",
  requestAddComment: "เพิ่มความคิดเห็น",
  requestReadAllComments: "ดูความคิดเห็นทั้งหมด",
  requestRecentComments: "ความคิดเห็นล่าสุด",
  requestServiceLocation: "สถานที่ขอใช้บริการ",

  requestStatus: "สถานะคำขอ",
  requestStatusDraft: "ฉบับร่าง",
  requestStatusSent: "ยื่นแล้ว",
  requestStatusNew: "ใหม่",
  requestStatusReturned: "ส่งกลับแก้ไข",
  requestStatusRefused: "ไม่รับ",
  requestStatusAccepted: "รับงานแล้ว",
  requestStatusAssigned : "มอบหมายงานแล้ว",
  requestStatusPreparing: "เตรียมงาน",
  requestStatusImplementing: "ปฏิบัติงาน",
  requestStatusDone: "ปฏิบัติเรียบร้อย",
  requestStatusClosed: "เสร็จสิ้นแล้ว",

  requestTotal: "จำนวนคำขอรวม",
  requestNew: "คำขอใหม่",
  requestOverDue: "ล่าช้า",
  requestImplementing: "ปฏิบัติ",
  requestCompleted: "แล้วเสร็จ",

  requestTableTitleNew: "คำขอใหม่",
  requestTableTitleOverDue: "คำขอที่ดำเนินการล่าช้า",
  requestTableTitleImplementing: "คำขอที่กำลังดำเนินการ",
  requestTableTitleCompleted: "คำขอที่ดำเนินการแล้วเสร็จ",
  requestTableTitleReceivedInOneMonth: "จำนวนคำขอจาก 1 เดือนที่ผ่านมา",

  requestConstruction: "ส่วนควบคุมการก่อสร้าง",
  requestUrbanPlanning: "ส่วนควบคุมอาคารและผังเมือง",
  requestCivilWorks: "ส่วนการโยธา",
  requestSanitary: "ส่วนช่างสุขาภิบาล",

  required: "ต้องการกรอกช่องนี้",
  resendLink: "ส่งลิงค์ใหม่อีกครั้ง",
  responsibleArea: "พื้นที่รับผิดชอบ",
  responsibleAreaProvince: "จังหวัดที่รับผิดชอบ",
  responsibleAreaCounty: "เทศบาลที่รับผิดชอบ",
  responsibleAreaTown: "เขตที่รับผิดชอบ",
  return: "ส่งกลับ",
  returnForEdit: "ส่งกลับเพื่อแก้ไข",
  returnForEditInstruction: "อธิบายให้แก้ไขอะไร",
  revoke: "ถอนสิทธิ์",
  revoked: "ถูกระงับ",

  rAskForService: "ขอรับบริการ",
  rReport: "แจ้งเหตุ",
  rMakeComplaint: "ร้องเรียน",
  rGiveOpinion: "แสดงความคิดเห็น",

  reset: "รีเซ็ต",
  result: "ผลการดำเนินงาน",
  retrieve: "กู้",
  ridOffice: "สำนักชลประทาน",
  ridProject: "โครงการชลประทาน",
  save: "จัดเก็บ",
  saveAsExcelFile: "จัดเก็บเป็นไฟล์ *.xlsx",
  saveDataToDatabase: "บันทึกข้อมูลสู่ฐานข้อมูล",
  scanFriendQRCode: "สแกนคิวอาร์โค้ดของเพื่อน",
  scanMe: "สแกนได้เลย จะเพิ่มฉันเข้าไปใน Hallo ของคุณ",
  scanQRCode: "สแกนคิวอาร์โค้ด",
  schedule: "ตารางงาน",
  search: "ค้นหา",
  select: "เลือก",
  selectAll: "เลือกทั้งหมด",
  selectMeasures: "เลือกตัววัด",
  selectObservedTimeRange: "เลือกช่วงเวลาตรวจวัด",
  selectAGpxOrZipFile: "เลือกไฟล์ %s หรือ %s",
  selectArea: "เลือกพื้นที่",
  send: "ส่ง",
  sender: "ผู้ส่ง",
  sendingEmail: "กำลังจัดส่งอีเมล์ให้คุณ โปรดรอสักครู่...",
  sent: "ส่ง",
  service: "การบริการ",
  serviceCategory: "ประเภทบริการ",
  sentViaEmail: "ส่งผ่านอีเมล์",
  set: "ตั้ง",
  seted: "ตั้งแล้ว",
  settings: "การตั้งค่า",
  share: "แชร์ในกลุ่ม",
  show: "แสดง",
  showOnMap: "แสดงบนแผนที่",
  shoreLine: "เส้นชายทะเล",
  since: "ตั้งแต่",
  size: "ขนาด",
  sms: "SMS",
  specify: "ระบุ",
  startDate: "วันที่เริ่ม",
  stationAndData: "สถานีและข้อมูลตรวจวัด %s",
  stationOverview: "ภาพรวม",
  street: "ถนน",
  submit: "ยื่น",
  supervisor: "หัวหน้างาน",
  surname: "นามสกุล",
  takeNewPhoto: "ถายรูปใหม่จากกล้อง",
  team: "ทีมงาน",
  termsAndConditions: "ข้อกำหนดและเงื่อนไข",
  test: "ทดสอบ",
  thai: "ไทย",
  then: "แล้ว",
  thungkula: "ทุ่งกุลาร้องไห้",
  till: "ถึง",
  timeAm: "เช้า",
  timePm: "บ่าย",
  to: "เพื่อ",
  toTo: "ลงใน",
  toClick: "คลิกที่",
  today: "วันนี้",
  toSpecify: "กำหนด",
  toSet: "สามารถตั้ง",
  town: "ตำบล",
  townName: "ชื่อตำบล",
  toYou: "มา",

  unit: "หน่วย",
  unitM: "ม.",
  unitM2: "ตร.ม.",
  unitSQM: "ตร.ม.",
  unitKM: "กม.",
  unitKM2: "ตร.กม.",
  unitSQKM: "ตร.กม.",
  unitMetric: "เมตริก",
  unitThai: "ไทย",
  unitRai: "ไร่",
  unitNgan: "งาน",
  unitWah: "ตร.วา",

  until: "จนกระทั่ง",
  update: "แก้ไข",
  updated: "ปรับปรุงข้อมูล",
  upload: "อัพโหลด",
  usage: "ใช้งาน",
  usageCounter: "จำนวนครั้งที่ใช้: %s",
  use: "ใช้",
  user: "ผู้ใช้",
  users: "ผู้ใช้",
  userId: "รหัสผู้ใช้",
  userName: "ชื่อผู้ใช้",
  userLog: "ประวัติการใช้งาน",
  userPrivilege: "สิทธิของผู้ใช้",
  userProfile: "ข้อมูลผู้ใช้",
  verify: "ตรวจสอบ",
  via: "โดยผ่าน",
  viaZH: "",
  video: "วีดีโอ",
  videoCall: "วีดีโอคอล",
  voice: "เสียง",
  valid: "ถูกต้อง",
  vsLastMonth: "เปรียบเทียบเดือนที่แล้ว",
  waiting: "โปรดรอสักครู่...",
  waterResource: "พื้นที่แหล่งน้ำ",
  waterDischargeArea: "พื้นที่ปล่อยน้ำ",
  watershed: "ขอบเขตลุ่มน้ำ",
  waterUseLayer: "ความต้องการใช้น้ำ ณ ปัจจุบัน",
  week: "สัปดาห์",
  weekDaysText: ["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัสฯ","ศุกร์","เสาร์"],
  welcome: "ยินดีต้อนรับ",
  welcomeUser: "ยินดีต้อนรับ! คุณ%s",
  width: "ความกว้าง",
  within: "ภายใน",
  wouldLikeTo: "มีความประสงค์ขอ",
  year: "พ.ศ.",
  years: "ปี",
  yearText: "ปี พ.ศ.",
  yes: "ใช่",
  yesterday: "เมื่อวาน",
  you: "คุณ",
  your: "",
  zipCode: "รหัสไปรษณีย์",

  resetMapRotation: "รีเซ็ตการหมุน",
  searchLocationOnMap: 'ค้นหาตำแหน่ง',
  panMapLeft: "ย้ายไปทางซ้าย",
  panMapRight: "ย้ายไปทางขวา",
  panMapUp: "ย้ายไปทางบน",
  panMapDown: "ย้ายไปทางล่าง",
  fullMapExtent: "เต็มพื้นที่เริ่มต้น",
  zoomIn: "ขยายแผนที่",
  zoomOut: "ย่อแผนที่",
  queryMapInfo: "สอบถามแผนที่",
  measureDistance: "วัดระยะทาง",
  measureArea: "วัดเนื้อที่",
  measureCoordinate: "วัดพิกัด",
  printMap: "พิมพ์แผนที่",
  changeBasemap: "เปลี่ยนแผนที่ฐาน",
  
  map: "แผนที่",
  mapBase: "แผนที่ฐาน",
  mapBases: "แผนที่ฐาน",

  binding: "ผูกติดกัน",
  bing: "Bing",
  bingAerial: "ภาพดาวเทียม",
  bingAerialWithLabels: "แผนที่ภาพ",
  bingRoad: "เส้นทางถนน",

  gistda: "GISTDA",
  gistdaGO: "ไทยโชติ",

  google: "Google",
  googleHybrid: "แผนที่ภาพ",
  googleRoad: "เส้นทางถนน",
  googleSatellite: "ภาพดาวเทียม",
  googleTerrain: "Terrain",

  osm: "OSM",
  osmCycleMap: "Cycle",
  osmMapnik: "Mapnik",
  osmOffline: "Offline",
  osmTransportMap: "เส้นทางคมนาคม",

  userGroup: "กลุ่มผู้ใช้",
  userRegistration: "ลงทะเบียนผู้ใช้",

  sAboutAlert: "กำหนดให้แจ้งเตือนด้วยเสียงและการสั่นเมื่อได้รับข้อความใหม่",
  sAboutAllowFindMyRequests: "ให้เพื่อนค้นหาคำร้องขอที่ประเภทเปิดเผยได้ทั้งหมด หรือเฉพาะรายการที่ส่งภายในจำนวนวันตามที่กำหนดเท่านั้น ไม่สามารถค้นหาคำร้องขอแบบที่ไม่เปิดเผย",
  sAboutBinding: "เมื่อผูกพันกันแล้ว คุณสามารถล็อกอินด้วยหมายเลขมือถือ หรือผ่าน Facebook, Twitter และ Google",
  sAboutBindingMobile:"เมื่อผูกพันกันแล้ว คุณจะได้รับบริการการตรวจสอบสิทธิ์แบบสองปัจจัยเพื่อรักษาความปลอดภัยของแอคเคาท์มากขึ้น",// นอกจากนี้ยังสามารถตั้งค่าเพื่อรับข้อมูลข่าวสารที่เป็นประโยชน์ต่อการใช้งานของคุณ",
  sAboutCatchword: "คำพุดติดปากดีๆ สร้างเสริมบุคลิกภาพที่ดีและเป็นเสน่ห์ที่ติดตัวไปตลอด",
  sAboutClearHalloChannels: "ประวัติเรื่องการสนทนาทั้งหมดจะถูกล้างทิ้ง",
  sAboutEmail: "ประโยชน์สำคัญในการใช้อีเมล์คือ ถ้าคุณลืมรหัสผ่านไปแล้วสามารถขอความช่วยเหลือจากเพื่อตั้งใหม่ นอกจากนี้ยังสามารถตั้งค่าเพื่อรับข้อมูลข่าวสารที่เป็นประโยชน์ต่อการใช้งานของคุณ",
  sAboutEmailConfirmation: "หลังจากคลิกที่ปุ่ม \"ตกลง\", เราจะส่งอีเมล์ยืนยันให้คุณตามที่อยู่ที่ระบุ. โปรดเปิดดูอีเมล์และทำตามคำแนะนำ",
  sAboutEnableNightMode: "กำหนดให้แจ้งเตือนด้วยเสียงและการสั่นหรือไม่ในช่วงเวลากลางคืน",
  sAboutLogout: "หลังจากล็อกเอาท์แล้ว คุณสามารถอ่านข่าวอย่างต่อเนื่อง แต่จะไม่สามารถยื่นคำร้องขอและแชทกับเพื่อน",
  sAboutPassword: "ประกอบด้วยอักขระ 6 ตัวขึ้นไป และต้องมีอักษรตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และ ตัวเลขอย่างน้อย 1ตัว",
  sAboutShowPreviousText: "ตั้งค่าแล้วจะแสดงชื่อผู้ส่งและช่วงเรกของข้อความบนหน้าจอ",
  sAboutUserId: "ประกอบด้วย 4 ถึง 12 ตัวอักษรหรือตัวเลข",
  sAboutUserName: "เป็นชื่อและนามสกุลตามบัตรประชาชน ใช้สำหรับการอ้างอิงในเรื่องคำร้องขอที่คุณส่งมา",
  sAboutUserNickname: "เป็นชื่อสำหรับการแสดงในรายชื่อผู้ติดต่อและแชทสด สามารถใช้ชื่อที่คุณชอบเพื่อแสดงความเป็นตัวของตัวเองอย่างแท้จริง",
  sAcceptThisRequest: "กรุณาคลิกที่ปุ่มยืนยันถ้าคุณต้องการรับคำขอนี้",
  sAreYouGoingToDeleteSelectedFeatures: "คุณจะลบข้อมูลแผนที่ที่เลือกไว้ ใช่หรือไม่?",
  sAreYouGoingToDeleteThisItem: "คุณจะลบรายการนี้ ใช่หรือไม่?",
  sAreYouGoingToGrantUserAccount: "คุณจะให้สิทธิ์การใช้งานแก้ คุณ%s ใช่หรือไม่?",
  sAreYouGoingToRevokeUserAccount: "คุณจะถอนสิทธิ์การใช้งานของ คุณ%s ใช่หรือไม่?",
  sAtLeast3PointsAreRequired: "ต้องเลือก 3 จุดขึ้นไปเป็นอย่างน้อย!",
  sActivateAccount: "การเปิดใช้งาน",
  sActivateAccountSuccessful: "คุณได้เปิดใช้บัญชีของคุณเรียบร้อย โดยคลิกที่ปุ่ม [เริ่มต้นใช้งาน] ที่ปรากฏแสดงในด้านล่าง คุณจะสามารถลงชื่อเข้าสู่ระบบได้เลยครับ",
  sStartToUse: "เริ่มต้นใช้งาน",

  sButRememberYourHalloId: "แต่คุณจำรหัสอัลโหลได้",
  sCancelDraftRequest: "คุณยังไม่ได้ส่งคำร้องขอฉบับนี้ ถ้ายกเลิกต่อนนี้ ข้อมูลที่สร้างจะหายไปทันที",
  sCancelRequestEdit: "คุณได้แก้ไขปรับปรุงคำร้องขอฉบันนี้แล้ว ถ้ายกเลิกต่อนนี้ ข้อมูลที่เปลี่ยนแปลงจะหายไปทันที",
  sChangeAccountItIsNotMine: "ขอเปลี่ยนแอคเคาท์อื่นๆ อันนี้ไม่ใช้ของฉัน",
  sChangeEmailSuccessful: "คุณได้เปลี่ยนอีเมล์เรียบร้อย อีเมล์ใหม่ของคุณคือ %s",
  sClickMapToMeasure: "คลิกบนแผนที่เพื่อวัด",
  sConfirmationCodeNotReceiveYet: "ยังไม่ได้รับรหัสยืนยัน กฎที่นี้",
  sConfirmationCodeSentToSMS: "ได้ส่งรหัสยืนยันไปที่ SMS ของมือถือคุณแล้ว",
  sConfirmationLinkNotReceiveYet: "ยังไม่ได้รับอีเมล์การยืนยัน กฎที่นี้",
  sConfirmationLinkSentToEmail: "ได้ส่งอีเมล์การยืนยันไปที่อีเมล์ของคุณแล้ว โปรดเปิดอีเมล์และดำเนินการตามคำแนะนำต่อไป",
  sConfirmationEamilRequired: "เคยส่งอีเมล์การยืนยันไปที่อีเมล์ของคุณแล้ว โปรดเปิดอีเมล์และดำเนินการตามคำแนะนำต่อไป",
  sCanSelectMax7Days: "เลือกได้สูงสุดจำนวน 7 วัน",
  sDeleteParagraph: "จะลบข้อความส่วนนี้จริงๆ ใช่ไหม?",
  sEmailConnectsYouAtAnyPlace: "อีเมล์เดียว เชื่อมคุณได้ทุกที่ทุกเวลา",
  sEmailResent: "ได้ส่งอีเมล์เรียบร้อย",
  sEmailVerified: "คุณได้ยืนยันอีเมล์เรียบร้อย สามารถล็อกอินได้เลยครับ",
  sEmailVerificationLinkInvalid: "การยืนยันอีเมล์ไม่ถูกต้อง ใส่อีเมล์ของท่านในช่องข้างล่างแล้วคลิกที่ปุ่ม [ขอส่งอีเมล์การยืนยันอีกครั้ง] เพื่อลองดูใหม่อีกครั้ง",
  sEnterPresentPassword: "รหัสผ่านปัจจุบัน",
  sEnterSignedUpEmail: "ใส่ที่อยู่อีเมล์ที่ท่านได้ลงทะเบียนไว้",

  sErrorConnection: "น่าจะมีปัญหาที่ไม่สามารถเชื่อมต่อกับอินเตอร์เน็ตได้",
  sErrorUnknown: "เราได้รับแจ้งปัญหาที่ไม่ได้คาดไว้จากเซิร์ฟเวอร์",

  sForgotPassword: "ฉันลืมรหัสผ่านไปแล้ว! จะทำอย่างไรดี",
  sForgotPasswordSent: "การขอรหัสผ่านใหม่เป็นที่เรียบร้อย เราได้ส่งรหัสผ่านใหม่ไปยังอีเมล์ของคุณแล้ว<br/>ขอบคุณครับ",
  
  sForLoginAndContact: "สำหรับการเข้าสู่ระบบและการติดต่อ",
  sForUserPermissionAndWorkFlowManagement: "สำหรับสิทธิการใช้งานและการบริหารงาน",

  sGeneralAutoSavePhoto: "จัดเก็บรูปถ่ายโดยอัตโนมัติ",
  sGeneralAutoSaveVideo: "จัดเก็บวิดีโอโดยอัตโนมัติ",
  sGeneralClearChatHistory:"ลบประวัติแชท",
  sGeneralStorage: "ที่จัดเก็บข้อมูล",
  sGeneralTextSize: "ขนาดตัวอักษร",
  sGeneralTurnOffSpeaker: "ปิดเสียง",

  sInvalidPassword: "รหัสผ่านไม่ตรงกับข้อกำหนด",
  sJustAVisitor: "อยากมาลองดูเฉยๆ กดตรงนี้ได้เลยครับ",
  sLoginInvalidAccount: "ข้อมูลล็อกอินไม่ถูกต้อง",
  sLoginWithFollowingAccount: "หรือล็อกอินด้วยแอคเคาท์จาก",
  sLogout: "คุณต้องการล็อกเอาท์จริงๆ ใช่ไหม?",
  sMeansYouAgree: "หมายความว่าคุณเห็นดวยกับ", //terms&Conditions
  sNewMessages: "ข้อความใหม่",
  sMustSelectAtLeastOnePhoto: "ต้องเลือกภาพถ่าย จำนวน 1 ภาพ เป็นอย่างน้อย",
  sMustSelectAtLeastOneVideo: "ต้องเลือกวิดีโอ จำนวน 1 ไฟล์ เป็นอย่างน้อย",
  sMustSelectOneCategory: "ต้องเลือกประเภทเรื่อง 1 เรื่อง",
  sMustSpecifyAllFieldsMarkedWithStar: "กรอกข้อมูลลงในช่องที่มีเครื่องหมายดอกจัน (*) ทุกช่อง",
  sMustSpecifyEmailAndOrMobileNo: "ต้องระบุอีเมล์หรือหมายเลขมือถือ ระบุทั้งสองจะดีที่สุด",
  sNoDataFound: "ไม่มีข้อมูล",
  sNoDataSelected: "ไม่ได้เลือกข้อมูล",
  sNoPhotoAvailable: "ไม่มีรูปถ่ายในอัลบั้ม",
  sNotAllowedToDeleteLandWithFarmerSSN: "ไม่อนุญาตให้ลบแปลงที่ได้ลงทะเบียนกับเกษตรกรแล้ว",
  sNotAllowedToDeleteLandDueTo: "ไม่อนุญาตให้ลบแปลงที่ไม่อยู่ในพื้นที่รับผิดชอบ",

  sNotificationEnableAlertSound: "แจ้งเตือนด้วยเสียง",
  sNotificationEnableNightMode: "การแจ้งเตือนในเวลากลางคืน",
  sNotificationEnableVibrate: "แจ้งเตือนด้วยการสั่น",
  sNotificationMessage: "แจ้งเตือนข้อความใหม่",
  sNotificationVideoCall: "แจ้งรับวิดีโอคอล",
  sNotificationShowPreviewText: "แสดงข้อความตัวอย่าง",

  sNumberOnly: "ตัวเลขเท่านั้น",
  sNumberOfPhotoSelected: "จำนวนรูปถ่ายที่เลือก",
  sOpenPasswordResetLinkInEmail: "คุณสามารถกำหนดรหัสผ่านใหม่ตามวิธีการที่ระบุในอีเมล์",
  sPasswordNotTheSame: "ยืนยันรหัสผ่านไม่ถูกต้อง โปรดกำหนดใหม่",
  sPasswordReset: "คุณได้เปลี่ยนรหัสผ่านเรียบร้อย ล็อกอินได้เลยครับ",
  sPasswordResetLinkSentToEmail: "ได้ส่ง Link เพื่อการกู้รหัสผ่านไปทางอีเมล์ของคุณแล้ว",
  sPasswordResetLinkSentToEmailFailed: "การขอรหัสผ่านพบข้อผิดพลาด ดังนี้",
  sPasswordResetLinkSentToEmailFailedInstruction: "โปรดแก้ไขข้อผิดพลาดให้เรียบร้อยและลองทำใหม่อีครั้ง",

  sPrivacyAllowAddMeByContactCard: "เพิ่มฉันได้จากนามบัตร",
  sPrivacyAllowAddMeByGroupChat: "เพิ่มฉันได้จากกลุ่มฮัลโหล",
  sPrivacyAllowAddMeByQRCode: "เพิ่มฉันได้จากคิวอาร์โค้ด",
  sPrivacyAllowFindMeByEmail: "ค้นหาฉันโดยที่อยู่อีเมล์",
  sPrivacyAllowFindMeByHalloId: "ค้นหาฉันโดยฮัลโหลไอดี",
  sPrivacyAllowFindMeByPhone: "ค้นหาฉันโดยเบอร์มือถือ",
  sPrivacyAllowFindMyRequests: "ให้ดูคำร้องขอตามที่ระบุ",
  sPrivacyInvitationRequireConfirmation: "การยืนยันการเพิ่มเพื่อน",

  sRegisterUser: "ยังไม่มีแอคเคาท์? ลงทะเบียนได้ที่นี่ครับ",
  sRegistrationLastStepCancel: "การลงทะเบียนกำลังจะเสร็จสิ้น ถ้ายกเลิกตอนนี้คุณจะต้องทำใหม่ทั้งหมด",
  sRegistrationName: "กรอกชื่อให้ครบถ้วน สามารถคลิกที่สัญญลักภาพเพื้อกำหนดรูปถ่ายของคุณด้วย",
  sRequestTitleUndefined: "ยังไม่ได้กำหนดชื่อเรื่องร้องขอ",
  sRequestToAccessAlbum: "ฮัลโหลต้องการอ่านอัลบั้มของคุณเพื่อแสดงรูปถ่ายให้เลือก",
  sResentConfirmationSMS: "ขอส่งรหัสยืนยันอีกครั้ง",
  sResentConfirmationEmail: "ขอส่งอีเมล์การยืนยันอีกครั้ง",
  sResetPasswordViaBoundedEmail: "กู้รหัสผ่านผ่านอีเมล์ที่ผูกติดกัน",
  sResetPasswordViaBoundedMobile: "กู้รหัสผ่านผ่านมือถือที่ผูกติดกัน",
  sResetPasswordViaAnotherEmail: "กู้รหัสผ่านผ่านอีเมล์อื่น",
  sResetPasswordViaAnotherMobile: "กู้รหัสผ่านผ่านมือถืออื่น",
  sSameEmailAsPresentOne: "อีเมล์นี้เหมือนกับอีเมล์ปัจจุบันของคุณ",
  sScanQRCode: "ใช้ปุ่มปรับระดับเสียงสามารถเปิดหรือปิดแฟลช",
  sSelectPhotoFromAlbum: "เลือกรูปจากอัลบั้ม",
  sSelectGetInfoToolAndClickonMapToQuery: "เลือกครื่องมือ GetInfo แล้วคลิกบนแผนที่เพื่อสอบถามข้อมูล",
  sShare: "เลือกแอปพลิเคชันที่จะแชร์",
  sTakeNewPhoto: "ถ่ายรูปใหม่จากกล้อง",
  sTapToAddText: "กดช่องนี้เพื่อใส่ข้อความ",
  sToChangePassword: "เพื่อการรักษาความปลอดภัยที่ดีขึ้น กรุณากรอกรหัสผ่านปัจจุบัน",
  sUserLastLogin: "ใช้แอคเคาท์ของครั้งที่แล้วดีกว่า",
  sWelcomeToHallo: "ยินดีต้อนรับสู่ฮัลโหล คุณสามารถเริ่มใช้งานได้แล้วคะ แนะนำให้กำหนดรหัสผ่านเป็นสิ่งที่ควรทำอันดับแรกคะ",
  sWelcomeToJoin: "ยินดีต้อนรับ",
  sWhatsUp: "กดที่นี่เพื่อกำหนดคำพูดติดปาก",
  sWillSendEmailTitle: "การยืนยันอีเมล์",
  sWillSendEmail: "เราจะส่งอีเมล์การยืนยันไปอย่างอีเมล์ของคุณตามที่อยู่ต่างต่อไปนี้",
  sWillSendSMSTitle: "การยืนยันเอบร์โทรศัพท์มือถือ",
  sWillSendSMS: "เราจะส่งรหัสยืนยันผ่าน SMS ไปยังหมายเลขโทรศัพท์ต่อไปนี้",
  sWrongPassword: "รหัสผ่านไม่ถูกต้อง ให้กรอกอีกครั้ง ถ้าคุณลืมรหัสผ่าน ให้ล็อกเอาท์ แล้วในหน้าส็อกอินคุณสามารถขอรหัสผ่านใหม่",
  sCanLoginUsingIdEmailMobileNo: "สามารถล็อกอินด้วยเลขประจำตัวประชาชน อีเมล์ หรือ หมายเลขโทรศัพท์มือถือ",

  //GISagro4.0
  mapping: "การทำแผนที่ / Mapping",
  measuring: "การรังวัด / Measuring",
  modeling: "การจำลอง / Modelling",
  monitoring: "การติดตาม / Monitoring",
  managing: "การบริหาร / Managing",
  undo: "ยกเลิกการแก้ไข",
  redo: "เรียกกลับมาใหม่",
  linkData: "การเชื่อมโยงข้อมูล",
  uploadCropData: "อัพโหลดข้อมูล%s",
  uploadGPX: "อัพโหลดข้อมูล *.gpx|*.shp",
  addPointXY: "สร้างหมุดด้วยพิกัด",
  addPoint: "สร้างหมุด",
  addPointAzimuthDistance: "สร้างหมุดด้วยมุมแอซิมัทและระยะห่าง",
  addPointBearingDistance: "สร้างหมุดด้วยมุมแบริงและระยะห่าง",
  addPointDxDy: "สร้างหมุดด้วย Dx,Dy",
  addPointA2BDistance: "สร้างหมุดระหว่างสองจุด",
  dragPoint: "ย้ายหมุด",
  deletePoint: "ลบหมุด",
  deletePoints: "ลบหมุดหลายหมุด",
  addPolygonXY: "ส้างแปลงด้วยพิกัด",
  addPolygon: "ส้างแปลง",
  addPolygonTrace: "สร้างแปลงอัตโนมัติ",
  cutPolygon: "ตัดแปลง",
  splitPolygon: "แบ่งแยกแปลง",
  scalePolygonArea: "ปรับปรุงแปลงตามเนื้อที่",
  transformPolygon: "ย่อ/ขยาย/หมุน แปลง",
  modifyPolygon: "แก้ไขรูปแปลง",
  dragPolygon: "ย้ายแปลง",
  indian75ToWgs84: "เปลี่ยน Indian75 เป็น WGS84",
  deletePolygon: "ลบแปลง",

  netSpeed: "ความเร็วเน็ต",
  adminArea: "ขอบเขตการปกครอง",
  dataSource: "หาจาก",
  cropType: "ชนิดพืช",
  cropFamilies: "ประเภทพืช",
  cropTypes: "ชนิดพืช",
  cropSpecies: "พันธุ์พืช",
  deedType: "ประเภทเอกสารสิทธิ์",
  grow: "ปลูก",
  harvest: "เก็บเกี่ยว",
  growOrHarvestYear: "ปีที่ปลูกหรือเก็บเกี่ยว",
  selectYear: "เลือกปี",
  searchResult: "ผลการค้นหา",

  rice: "ข้าว",
  maize: "ข้าวโพด",
  sugarcane: "อ้อย",
  cassava: "มันสำปะหลัง",
  
  mlLandMonument: "หลักหมุดของแปลง",
  mlFromAllSystems: "ชั้นข้อมูลจากระบบ DOAE",
  mlFarmland: 'แปลงปลูกในระบบ GISagro',
  mlFarmlandRIPBY: "เชื่อมทะเบียนเกษตรกรปีปัจจุบัน", //"วาดปีงบประมาณ %s",
  mlFarmlandRIBY: "เชื่อมทะเบียนเกษตรกรปี %s", //"วาดปีงบประมาณ %s",
  mlFarmlandRBBY: "เชื่อมทะเบียนเกษตรกรก่อนปี %s", //"วาดปีก่อนงบประมาณ %s",
  mlFarmlandR: "ระบุชื่อเกษตรกร",
  mlFarmlandNR: "ไม่ระบุชื่อเกษตรกร",

  gBaseMapImagery: "แผนที่ฐาน/ภาพถ่ายดาวเทียม",
  layerGoogleStreetMap: "แผนที่เส้นทางถนนของกูเกิ้ล",
  layerGoogleHybridMap: "แผนที่ภาพของกูเกิ้ล",
  layerSatelliteImageryMunisan: "ภาพถ่ายดาวเทียมเทศบาลนครปากเกร็ด"
};